import type { ComponentType } from 'react';

import { autorun, when } from 'mobx';

import { SOCKET_KYC_FORCED } from '../../config/constants';
import { socket } from '../../services/socket';
import { EnumKycStatus } from '../../services/types';
import type { FeatureFetchStatus, IFeatureManagerStore } from '../feature-manager/types';
import type { RootStore } from '../RootStore';

export class ForceKycStore implements IFeatureManagerStore<'ForceKyc'> {
  private readonly rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    autorun(() => {
      const forceKycHandler = this.handleForcedKyc.bind(this);

      if (this.rootStore.authStore.authorized) {
        socket.on(SOCKET_KYC_FORCED, forceKycHandler);
      } else {
        socket.off(SOCKET_KYC_FORCED, forceKycHandler);
        this.kycForced = false;
      }
    });
  }

  public dialogTypes = ['ForceKyc'] as const;
  public ForceKycReactionComponent: ComponentType | null = null;

  private kycForced: boolean = false;

  private handleForcedKyc() {
    this.kycForced = true;
    this.rootStore.featureManagerStore.addDialogsToSequenceQueue(['ForceKyc']);
  }

  async fetch(): Promise<FeatureFetchStatus> {
    if (!this.rootStore.userStore.profile == null) {
      await when(() => this.rootStore.userStore.profile != null);
    }

    return 'READY';
  }

  startDialogs(): boolean {
    if (
      this.ForceKycReactionComponent &&
      (this.kycForced || this.rootStore.userStore.profile?.kycStatus === EnumKycStatus.requested)
    ) {
      this.rootStore.portalStore.openPortal(this.ForceKycReactionComponent, {
        beforeClose: () => {
          this.kycForced = false;
          this.rootStore.featureManagerStore.onDialogFinished('ForceKyc');
        },
      });

      return true;
    }

    return false;
  }
}
